import React, {PureComponent} from 'react';
import {IBookingState} from "../components/Bookings/models";
import {BookingsService} from "../components/Bookings/Bookings.service";
import Spinner from "react-bootstrap/Spinner";
import {BookingsTable} from '../components/Bookings/BookingsTable';
import {BookingSearchBar} from '../components/Bookings/BookingsSearchBar';
import {AuthenticationContext} from "../services/context/authentication.context";
import { PageProps } from 'models/page';
import { LOCAL_STORAGE_KEYS } from 'common/constants/localStorageKeys';

export class Bookings extends PureComponent<PageProps, IBookingState> {

    static contextType = AuthenticationContext;
    constructor(props: PageProps) {
        super(props);
        this.state = {
            customerId: Number(localStorage.getItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID)),
            loading: true,
            bookingData: []
        };
        this.props.onLoadValidatePage();
    }

    getBooking = () => {
        BookingsService.getBookingData(this.state.customerId).then(data => {
            this.setState({
                bookingData: data,
                loading: false
            })
        }).catch((reason: any) => {
            console.error(reason);
            this.setState({loading: false});
        })
    };

    updateCustomerId = () => {
        if (this.context.state.customerId !== this.state.customerId) {
            this.setState({
                ...this.state,
                loading: true,
                customerId: this.context.state.customerId,
            }, () => {
                this.getBooking();
            });
        }
    };

    componentDidMount(): void {
        this.getBooking();
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<IBookingState>, snapshot?: any): void {
        this.updateCustomerId();
    }

    render() {
        return (
            <div className="document-rows__container">

                <BookingSearchBar/>
                {/*<div className="row">*/}
                {/*    <div className="col">*/}
                {
                    this.state.loading &&
                    <div className="text-center"><Spinner animation={"grow"}/></div>
                }
                {
                    !this.state.loading &&
                    <BookingsTable bookingsData={this.state.bookingData}/>
                }
                {/*</div>*/}
                {/*</div>*/}
            </div>
        );
    }
}
